import { useLocation } from "react-router-dom";
type TUseSearchQuery = () => (p: string) => string | null;
export const useSearchQuery: TUseSearchQuery = () => {
  const { search } = useLocation();
  return (paramName: string): string | null => new URLSearchParams(search).get(paramName);
};
